import { z } from 'zod'

/** 訂閱/取消電子報資料 Schema */
export const myAccountSubscribeNewsletterSchema = z.object({
  /** 是否訂閱BizFam各項資訊 */
  subscribeBizFamVariousInformation: z.boolean(),
  /** 是否訂閱異業合作促銷訊息 */
  subscribePromotional: z.boolean()
})

/** 訂閱/取消電子報資料 */
export interface MyAccountSubscribeNewsletter
  extends z.infer<typeof myAccountSubscribeNewsletterSchema> {}

export class MyAccountSubscribeNewsletter {
  constructor() {
    return {
      subscribeBizFamVariousInformation: false,
      subscribePromotional: false
    }
  }
}
